import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

export class NoteSelection {
    public static clearNoteSelection = () => {
        const model = this.getSelectionService()?.currentSlide?.noteData;
        model?.noteInstance?.triggerBlur({ needUpd8: true });
    };

    private static getSelectionService() {
        return this.getAppService()?.viewableServiceLayer?.selectionService;
    }

    private static getAppService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices | IMobileEditorAppServices);
    }
}
